import React from 'react';
import {
  Button,
  Box,
  Typography,
  TextField,
  Grid,
  Paper,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForgetPassword } from 'hooks/useUserAuth';
import { snackbarService } from 'services/snackbarService';
import { useNavigate } from 'react-router-dom';
import useGlobalStyles from 'styles/globalStyles';
import CustomButton from 'components/buttons/CustomButton/CustomButton';

const ForgetPasswordPage: React.FC = () => {
  const navigate = useNavigate();
  const globalStyles = useGlobalStyles();

  let forgetSchema = yup.object().shape({
    email: yup
      .string()
      .trim()
      .email('Must use valid email address')
      .required('Email is required')
  });

  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors, isValid },
  } = useForm({
    resolver: yupResolver(forgetSchema),
  });

  const { mutate: forgotMutation, isLoading } = useForgetPassword(
    (res: any) => {
      const { data, status_code: statusCode } = res;
      if (statusCode === 200) {
        snackbarService.showSnackbar('Email has been sent', 'success');
        navigate('/reset-password', {
          state: { email: getValues('email') },
        });
      } else {
        snackbarService.showSnackbar(data, 'error');
      }
    },
    (error: any) => { }
  );


  const onSubmit = async (values: any) => {
    forgotMutation(values.email);
  };

  return (
    <div>
      <Box>
        <Grid
          className={globalStyles.boxSignIn}
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Grid
            container
            size={{ xs: 12, sm: 12, md: 5 }}
            sx={{ justifyContent: 'center', alignItems: 'center' }}
            className={globalStyles.bigBox}>
            <Paper variant="outlined" className={globalStyles.paperSignIn}>
              <Box mb={3}>
                <Typography variant="subtitle1">Forgot password</Typography>
              </Box>
              <form
                onSubmit={handleSubmit(onSubmit)}
                className='container'
              >
                <Typography
                  variant="body2"
                  className={globalStyles.forgetPasswordHeader}
                >
                  We need your registered e-mail address to send you a reset
                  password code.
                </Typography>
                <TextField
                  {...register('email')}
                  label="Email"
                  className='textField'
                  margin="normal"
                  helperText={errors.email?.message}
                  fullWidth
                  error={!!errors.email}
                  variant='standard'
                />
                <CustomButton
                  fullWidth
                  text='Submit'
                  type='submit'
                  disabled={!isValid}
                  loading={isLoading}
                />
              </form>
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default ForgetPasswordPage;
